export default __webpack_public_path__ + "static/210526_妲絲刷關活動熱更完成_en-66c95b62f9abc3c1fb1154496900c13d.png";